import { render, staticRenderFns } from "./TableRegular.vue?vue&type=template&id=88605438"
import script from "./TableRegular.vue?vue&type=script&lang=js"
export * from "./TableRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports